export enum AlertLevelEnum
{
  ALERT_LEVEL_0 = 0, // Le niveau 0 d'alerte SMS/Email
  ALERT_LEVEL_1 = 1, // Premier niveau d'alerte SMS/Email
  ALERT_LEVEL_2 = 2, // Second niveau d'alerte SMS/Email
  ALERT_LEVEL_3 = 3, // Troisième niveau d'alerte SMS/Email
}